// blog page

// const sliderContainer = document.querySelector('.blog-slider-main');
// const slideRight = document.querySelector('.blog-right');
// const slideLeft = document.querySelector('.blog-left');
// const upButton = document.querySelector('.up-button');
// const downButton = document.querySelector('.down-button');
// const slidesLength = slideRight.querySelectorAll('div').length;

// let activeSlideIndex = 0;

// slideLeft.style.top = `-${(slidesLength - 1) * 100}vh`;

// slideRight.addEventListener('wheel', () => changeSlide('up'));
// slideLeft.addEventListener('wheel', () => changeSlide('down'));
// upButton.addEventListener('click', () => changeSlide('up'));
// downButton.addEventListener('click', () => changeSlide('down'));

// const changeSlide = (direction) => {
//   console.log(changeSlide)
//     const sliderHeight = sliderContainer.clientHeight;
//     if(direction === 'up') {
//         activeSlideIndex++;
//         if(activeSlideIndex > slidesLength - 1) {
//             activeSlideIndex = 0;
//         }
//     } else if (direction === 'down') {
//         activeSlideIndex--;
//         if(activeSlideIndex < 0) {
//             activeSlideIndex = slidesLength - 1;
//         }
//     }
//     slideRight.style.transform = `translateY(-${activeSlideIndex * sliderHeight}px)`;
//     slideLeft.style.transform = `translateY(${activeSlideIndex * sliderHeight}px)`;
// }
// $(document).ready(function(){
//   $(".blog-details #tab-1 a").html("READ NOW");
//   $(".blog-details #tab-2 a").html("GET THE GUIDE");
//   $(".blog-details #tab-3 a").html("GLOBAL® WEBSTORE");
//   $(".blog-details #tab-4 a").html("WATCH THE VIDEO");
// });


if (window.location.href === 'https://www.globalknives.co.za/products' || window.location.href === 'https://globalknives.co.za/products/' || window.location.href === 'https://www.globalknives.co.za/products/' ) {
            // Redirect to the desired URL
            window.location.href = 'https://www.globalknives.co.za/';
}

if (window.location.href === 'https://www.globalknives.co.za/collections' || window.location.href === 'https://www.globalknives.co.za/collections/' || window.location.href === 'https://www.globalknives.co.za/collections/' ) {
            // Redirect to the desired URL
            window.location.href = 'https://www.globalknives.co.za/collections/all';
}


setTimeout(() => {
  var priceItems = document.querySelectorAll(".price-item--sale");

  priceItems.forEach(function (element) {
    var priceText = element.textContent.trim();
    var modifiedText = priceText.replace("R ", "R");
    element.textContent = modifiedText;
  });
}, 500);

document.addEventListener('DOMContentLoaded', () => {
  // Select all accordion elements
  const accordions = document.querySelectorAll('.product__accordion')

  // Find the element with the `product-tab-collapsible` class
  const collapsibleElement = document.querySelector(
    '.product__accordion.product-tab-collapsible',
  )

  // Move the collapsible element to the end
  if (collapsibleElement) {
    collapsibleElement.parentNode.appendChild(collapsibleElement)
  }
})
